import { render, staticRenderFns } from "./facturesListe.vue?vue&type=template&id=4a0b38a5&"
import script from "./facturesListe.vue?vue&type=script&lang=js&"
export * from "./facturesListe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports